import { useTheme } from '@mui/material';
import { ARC_THICKNESS, CENTER, DEFAULT_DIAL_OPTIONS, SIZE } from './constants';
import { getArcPath, getPercents } from './helpers';
import { ArcProps } from './types';

const Arc = ({ value, options }: ArcProps) => {
  const theme = useTheme();

  const { min, max, angleOffset, angleRange } = {
    ...DEFAULT_DIAL_OPTIONS,
    ...options,
  };

  const endAngle = angleOffset + angleRange;

  const arcPath = getArcPath(CENTER, ARC_THICKNESS, angleOffset, endAngle);

  const valueInPercents = getPercents(value, min, max);
  const valueArcAngle = angleRange * valueInPercents;
  const valueArcPath = getArcPath(
    CENTER,
    ARC_THICKNESS,
    angleOffset,
    angleOffset + valueArcAngle
  );

  return (
    <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
      <path
        d={arcPath}
        fill="none"
        stroke={theme.palette.grey[600]}
        strokeWidth={ARC_THICKNESS}
      />
      <path
        d={valueArcPath}
        fill="none"
        stroke={theme.palette.primary.main}
        strokeWidth={ARC_THICKNESS}
      />
    </svg>
  );
};

export default Arc;
